import classNames from "classnames";

import { CCard, CCardBody, CCol, CRow } from "@coreui/react";

import { usePermissionCheck } from "src/1/common/components/others";
import { ENTITY_GROUP_CODE, PERMISSION_VALUE } from "src/configs/constant";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { CActionGroup } from "_components/others";

export const ComboItemToolbar = ({
  onAdd,
  onEdit,
  onRemove,
  canEdit,
  canRemove,
}) => {
  const checkPermission = usePermissionCheck();

  const onClick = (key) => {
    switch (key) {
      case "add":
        return onAdd();
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      default:
        return onAdd();
    }
  };

  const isMobile = useMobileDevice();

  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <CRow>
          <CCol xs="12" className="action">
            <div>
              <CActionGroup
                onClick={onClick}
                canAdd={checkPermission({
                  [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.CREATE,
                })}
                canEdit={
                  canEdit &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.UPDATE,
                  })
                }
                canRemove={
                  canRemove &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.DELETE,
                  })
                }
              />
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};
